export default __webpack_public_path__ + "locales/hy-AM/MainBar.json?hash=8dc00c66b0abb7377c67642902b802a3";